import { render, staticRenderFns } from "./YearInfo.vue?vue&type=template&id=8df80890&scoped=true"
import script from "./YearInfo.vue?vue&type=script&lang=js"
export * from "./YearInfo.vue?vue&type=script&lang=js"
import style0 from "./YearInfo.vue?vue&type=style&index=0&id=8df80890&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df80890",
  null
  
)

export default component.exports